import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LanguageModule } from '@language';
import {
    ShActionItemComponent,
    ShFieldLabelComponent,
    ShFormGroupComponent,
    ShFormMultiSelectModule,
    ShFormTagListModule,
    ShFormTextInputComponent,
    ShIconModule,
    ShNotificationComponent,
    ShProfileFormModule
} from '@stylehaven/components';
import { SharedElementsModule } from '../elements/shared/shared-elements.module';
import { ExternalWebserviceModule } from '../external-webservice/external-webservice.module';
import { FormPermissionsModule } from '../form-permissions/form-permissions.module';
import { FormThesaurusModule } from '../form-thesaurus/form-thesaurus.module';
import { AddressInputFieldComponent } from '../generic-form-extensions/components/input/address-input-field/address-input-field.component';
import { AddressReadonlyFieldComponent } from '../generic-form-extensions/components/readonly/address-readonly-field/address-readonly-field.component';
import { ThesaurusModule } from '../thesaurus/thesaurus.module';
import { AddressInputListComponent } from './components/input/address-input-list/address-input-list.component';
import { ComplexListInputFieldComponent } from './components/input/complex-list-input-field/complex-list-input-field.component';
import { JdnInputFieldComponent } from './components/input/jdn-input-field/jdn-input-field.component';
import { JdnWebservice } from './components/input/jdn-input-field/jdn-webservice.service';
import { PermissionsInputFieldComponent } from './components/input/permissions-input-field/permissions-input-field.component';
import { TagInputFieldComponent } from './components/input/tag-input-field/tag-input-field.component';
import { ThesaurusInputFieldComponent } from './components/input/thesaurus-input-field/thesaurus-input-field.component';
import { WebserviceListInputFieldComponent } from './components/input/webservice-list-input-field/webservice-list-input-field.component';
import { ComplexListReadonlyFieldComponent } from './components/readonly/complex-list-readonly-field/complex-list-readonly-field.component';
import { PermissionsReadonlyFieldComponent } from './components/readonly/permissions-readonly-field/permissions-readonly-field.component';
import { ThesaurusReadonlyFieldComponent } from './components/readonly/thesaurus-readonly-field/thesaurus-readonly-field.component';
import { WebserviceListReadonlyFieldComponent } from './components/readonly/webservice-list-readonly-field/webservice-list-readonly-field.component';
@NgModule({
    declarations: [
        AddressInputFieldComponent,
        AddressReadonlyFieldComponent,
        AddressInputListComponent,
        ComplexListInputFieldComponent,
        ComplexListReadonlyFieldComponent,
        JdnInputFieldComponent,
        PermissionsInputFieldComponent,
        PermissionsReadonlyFieldComponent,
        TagInputFieldComponent,
        ThesaurusInputFieldComponent,
        ThesaurusReadonlyFieldComponent,
        WebserviceListInputFieldComponent,
        WebserviceListReadonlyFieldComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        ThesaurusModule,
        SharedElementsModule,
        ExternalWebserviceModule,
        FormPermissionsModule,
        FormThesaurusModule,
        ShIconModule,
        ShFormTagListModule,
        ShFormMultiSelectModule,
        ShActionItemComponent,
        ShFormTagListModule,
        ShNotificationComponent,
        LanguageModule,
        ShFormGroupComponent,
        ShFormTextInputComponent,
        ShProfileFormModule,
        ShFieldLabelComponent
    ],
    exports: [
        AddressInputFieldComponent,
        AddressReadonlyFieldComponent,
        AddressInputListComponent,
        ComplexListInputFieldComponent,
        ComplexListReadonlyFieldComponent,
        JdnInputFieldComponent,
        PermissionsInputFieldComponent,
        PermissionsReadonlyFieldComponent,
        TagInputFieldComponent,
        ThesaurusInputFieldComponent,
        ThesaurusReadonlyFieldComponent,
        WebserviceListInputFieldComponent,
        WebserviceListReadonlyFieldComponent
    ],
    providers: [JdnWebservice]
})
export class GenericFormExtensionsModule {}

export { AddressInputFieldComponent } from './components/input/address-input-field/address-input-field.component';
export { AddressInputListComponent } from './components/input/address-input-list/address-input-list.component';
export { ComplexListInputFieldComponent } from './components/input/complex-list-input-field/complex-list-input-field.component';
export { JdnInputFieldComponent } from './components/input/jdn-input-field/jdn-input-field.component';
export { PermissionsInputFieldComponent } from './components/input/permissions-input-field/permissions-input-field.component';
export { TagInputFieldComponent } from './components/input/tag-input-field/tag-input-field.component';
export { ThesaurusInputFieldComponent } from './components/input/thesaurus-input-field/thesaurus-input-field.component';
export { WebserviceListInputFieldComponent } from './components/input/webservice-list-input-field/webservice-list-input-field.component';
export { AddressReadonlyFieldComponent } from './components/readonly/address-readonly-field/address-readonly-field.component';
export { ComplexListReadonlyFieldComponent } from './components/readonly/complex-list-readonly-field/complex-list-readonly-field.component';
export { PermissionsReadonlyFieldComponent } from './components/readonly/permissions-readonly-field/permissions-readonly-field.component';
export { ThesaurusReadonlyFieldComponent } from './components/readonly/thesaurus-readonly-field/thesaurus-readonly-field.component';
export { WebserviceListReadonlyFieldComponent } from './components/readonly/webservice-list-readonly-field/webservice-list-readonly-field.component';
